"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteDashboard = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  viewBox: "0 0 224 150",
  ...props,
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      id: "a",
      x: "8.205",
      y: "0",
      width: "70.553",
      height: "52",
      rx: "4.411"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      id: "b",
      x: "8.205",
      y: "0",
      width: "70.553",
      height: "35",
      rx: "4.411"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
      id: "c",
      x: "8.205",
      y: "39",
      width: "70.553",
      height: "34",
      rx: "4.411"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M127.825 24.898c-14.104-.501-27.538-5.171-40.364-10.28C74.634 9.509 61.927 3.848 48.16 1.14 39.308-.6 29.182-.846 22.048 4.02 15.18 8.7 11.447 16.428 10.255 23.924c-.897 5.653.091 11.956 2.548 17.242 1.708 3.67 4.739 6.754 6.836 10.268 7.291 12.23 2.141 27.313-5.767 39.255-3.7 5.602-8.008 10.947-10.868 16.909-2.86 5.962-4.184 12.796-1.682 18.88 2.482 6.03 8.393 10.558 14.797 13.742C29.126 146.691 43.976 150 59 150c33.5 0 66.6-.1 99.926-.1 12.29 0 24.607-.75 36.686-2.697 6.706-1.082 13.629-2.797 18.496-6.94 6.182-5.263 7.714-14.165 3.571-20.759-6.94-11.057-26.151-13.802-31.007-25.676-2.673-6.533.072-13.811 3.956-19.88 8.333-13 22.3-24.404 23.036-39.264.507-10.205-6.208-20.427-16.59-25.255-10.883-5.067-25.972-4.424-34.001 3.953-8.267 8.64-22.795 11.96-35.248 11.516z",
      fillOpacity: ".14",
      fill: "#1657E2",
      className: "fill-primary",
      fillRule: "nonzero"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0 39)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fill: "#88A9F0",
        className: "fill-primary-opa50",
        xlinkHref: "#a"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fillOpacity: ".499",
        fill: "#FFF",
        xlinkHref: "#a"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: "#FFF",
        width: "74.393",
        height: "52",
        rx: "4.411"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M8.752 8.719h17.504v17.438H8.752zM30.633 8.719h35.009v4.36H30.633zM30.633 17.438h26.803v4.36H30.633z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M8.752 30.517h18v4.36h-18zM8.752 39.517h18v4.36h-18zM30.256 30.517h28v4.36h-28zM30.256 39.517h28v4.36h-28z"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M114 90.8L133 67l20 23.8V150h-39z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#FFF",
        d: "M52 91h62v59H52z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M105 140l.296.005c5.011.161 9.046 4.408 9.2 9.684l.004.311-.296-.005c-5.011-.161-9.046-4.408-9.2-9.684L105 140z",
        fill: "#1657E2",
        className: "fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        className: "fill-primary40",
        d: "M124 140l-.005.311c-.15 5.17-4.028 9.353-8.9 9.67l-.3.014-.295.005.005-.311c.15-5.17 4.028-9.353 8.9-9.67l.3-.014L124 140z",
        fill: "#779DED"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M70.692 67H133l-18.692 24H52z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M89.5 104.2H102v12.4H89.5zM89.5 128.2H102v12.4H89.5zM64.5 104.2H77v12.4H64.5z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#091E43",
        d: "M127 104.2h12.5v12.4H127zM127 128.2h12.5v12.4H127z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M64.5 128H77v22H64.5z"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(145 39)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fill: "#88A9F0",
        className: "fill-primary-opa50",
        xlinkHref: "#b"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fillOpacity: ".499",
        fill: "#FFF",
        xlinkHref: "#b"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fill: "#88A9F0",
        className: "fill-primary-opa50",
        xlinkHref: "#c"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
        fillOpacity: ".499",
        fill: "#FFF",
        xlinkHref: "#c"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: "#FFF",
        width: "74.393",
        height: "35",
        rx: "4.411"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: "#FFF",
        y: "39",
        width: "74.393",
        height: "34",
        rx: "4.411"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#C3D0D8",
        d: "M11.633 49.719h48v4.36h-48zM11.633 58.438h36.75v4.36h-36.75z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: "#1657E2",
        className: "fill-primary",
        d: "M8.752 8.719h17.504v17.438H8.752zM30.633 8.719h35.009v4.36H30.633zM30.633 17.438h26.803v4.36H30.633z"
      })]
    })]
  })]
});
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteDashboard')(IllustrationMySiteDashboard);